/**
 * Krok FUNK1 bod 3 — DUVOD, PROC PROVERENI SELHALO, JAKO VETA.
 *
 * Nalez z pruchodu celou aplikaci (R.B. 4. 10. 2026): na `/audit` stalo
 * „Důvod chyby: unsupported_property_kind". Kod zapsal server
 * (`apps/api/src/routes/audit-run-batches.ts`) a UI ho vypsalo tak, jak
 * prisel.
 *
 * Duvody chodi ze serveru ve TREKH podobach a kazda ma svoje misto:
 *   1. CISTY KOD — `unsupported_property_kind`, `engine_failure`,
 *   2. KOD S DVOJTECKOU — `timeout: běh překročil tvrdý limit 30 min`
 *      (`apps/worker/src/audit-queue/run-limits.ts`),
 *   3. HOLA CHYBA z vyjimky — cokoli, co vratil `error.message`.
 *
 * Katalog zna 1 a 2; pro 3 rozhoduje TYZ filtr, jaky uz ma zbytek adminu
 * (`brokerText` / `isMachineText`, krok UX1) — lidska veta projde, strojovy
 * text nahradi obecna veta s tim, co ma clovek udelat. Zadny druhy seznam
 * „co je strojove" tu nevznika.
 */

import { t, tryT, type MessageKey } from '@reos/i18n';
import { brokerText } from './broker-text.js';

const cs = { locale: 'cs' } as const;

/** Kod pred dvojteckou, nebo cely retezec, kdyz dvojtecka neni. */
function codeOf(raw: string): string {
  const head = raw.split(':')[0] ?? raw;
  return head.trim();
}

/**
 * Lidska veta k duvodu selhani. Vzdy vraci neco, co jde precist — prazdny
 * retezec by na obrazovce zustal jako „Důvod chyby: ".
 */
export function failureReasonSentence(raw: string | null | undefined): string {
  const unknown = t('webAdmin.failureReason.unknown', cs);
  if (raw === null || raw === undefined || raw.trim() === '') return unknown;
  const text = raw.trim();
  const fromCatalog = tryT(`webAdmin.failureReason.${codeOf(text)}` as MessageKey, cs);
  if (fromCatalog !== undefined) return fromCatalog;
  return brokerText(text, { fallback: unknown });
}
